<template>
    <!-- eslint-disable -->
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="50" height="50" viewBox="0 0 50 50">
        <defs>
            <clipPath id="clip-Email">
                <rect width="50" height="50"/>
            </clipPath>
        </defs>
        <g id="Email" clip-path="url(#clip-Email)">
            <g id="noun_Email_1740158" transform="translate(-14.176 132.26)">
                <g id="Groupe_2916" data-name="Groupe 2916" transform="translate(24.176 -118.403)">
                    <path id="Tracé_2995" data-name="Tracé 2995" d="M10.988,973.362A3.037,3.037,0,0,0,8,976.432v15.512a3.048,3.048,0,0,0,2.988,3.081h25.4a3.048,3.048,0,0,0,2.988-3.081V976.432a3.037,3.037,0,0,0-2.988-3.07Zm0,1.494h25.4A1.482,1.482,0,0,1,37,975L24.656,986.423a1.341,1.341,0,0,1-1.9,0L10.381,975A1.479,1.479,0,0,1,10.988,974.856Zm-1.471,1.377,8.766,8.1-8.6,8.369a1.668,1.668,0,0,1-.187-.758V976.432a1.7,1.7,0,0,1,.024-.2Zm28.339.011a1.678,1.678,0,0,1,.023.187v15.512a1.678,1.678,0,0,1-.175.747l-8.579-8.369,8.731-8.077Zm-9.816,9.081,8.392,8.205H10.953l8.427-8.194,2.358,2.183a2.9,2.9,0,0,0,3.933,0l2.369-2.195Z" transform="translate(-8 -973.362)" :fill="color"/>
                </g>
            </g>
        </g>
    </svg>
</template>
<script>
import { Colorable } from '../../mixins';

export default {
    name: 'IconEmail',
    mixins: [Colorable],
};
</script>

